module.exports = __webpack_public_path__ + "static/media/Rectangle269.974cbb53.svg";